import { client } from "@/http/client"

import { IPagingResponse, IRequestParams } from "@/types/api"
import { ITransportType } from "@/types/ITransportType"

export const getTransportTypes = (params: IRequestParams): Promise<IPagingResponse<ITransportType>> =>
    client.get("/TransportTypes", {
        params
    })
